import React from "react";
import { Candidate as CandidateItem } from "./Candidate";
import Candidate from "../../apiResources/Candidate";

const CandidateItemCardStyleOverrides = {
  border: "1px solid #e6e6e6",
  padding: "1rem",
  marginBottom: "1rem",
  borderRadius: "5px",
  width: "100% !important",
  position: "relative",
};

const CandidateListCard = (props: Props) => {
  const { candidate, onEditClick } = props;

  return (
    <CandidateItem
      candidate={candidate}
      onEditClick={onEditClick}
      style={CandidateItemCardStyleOverrides}
    />
  );
};

type Props = {
  candidate: Candidate;
  onEditClick: (candidate: Candidate) => void;
};

export default CandidateListCard;
